import axios from 'axios';
import { DISTRIBUTION_TYPE_EQUALLY, DISTRIBUTION_TYPE_PARTS, DISTRIBUTION_TYPE_VALUE } from './panels/Items/components/DistributionTypeTabsComponent';
import { prepareString } from './helpers/helpers';

class HttpClient {
  #host = '';
  #token = null;
  #lang = 'ru';
  #initUserData = {};
  #events = {
    1: {
      id: 1,
      name: 'Picnic',
      invite: 'qwe123qwe123qwe123',
      invite_link: 'https://link.who2who.top/qwe123qwe123qwe123',
      image: 'https://img.freepik.com/free-vector/flat-international-picnic-day-background_23-2150337710.jpg',
      image_s: 'https://img.freepik.com/free-vector/flat-international-picnic-day-background_23-2150337710.jpg',
    }
  };
  #users = {
    1: {
      id: 1,
      telegram_id: 1,
      name: 'Tom',
      img: 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairDreads01&accessoriesType=Prescription01&hatColor=PastelOrange&hairColor=BlondeGolden&facialHairType=BeardMajestic&facialHairColor=Brown&clotheType=Hoodie&clotheColor=Heather&eyeType=EyeRoll&eyebrowType=FlatNatural&mouthType=Concerned&skinColor=Pale',
      type: 'telegram',
      payment_info: ''
    },
    2: {
      id: 2,
      telegram_id: 2,
      name: 'Alex',
      img: 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairTheCaesarSidePart&accessoriesType=Wayfarers&hairColor=Red&facialHairType=BeardLight&facialHairColor=Blonde&clotheType=ShirtVNeck&clotheColor=Gray01&eyeType=Cry&eyebrowType=SadConcerned&mouthType=Serious&skinColor=Pale',
      type: 'telegram',
      payment_info: ''
    },
    3: {
      id: 3,
      telegram_id: 3,
      name: 'Mary',
      img: 'https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&facialHairColor=BrownDark&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light',
      type: 'telegram',
      payment_info: ''
    }
  };
  #itemGroups = {
    1: {
      id: 1,
      name: "Кафе",
    },
    2: {
      id: 2,
      name: "Ужин",
    },
  }
  #items = [
    {
      id: 1,
      event_id: 1,
      type: 'payment',
      name: 'Vegetables',
      comment: '',
      amount: 5.5,
      group: this.#itemGroups[1],
      date: '2024-04-06T13:20:00+00:00',
      creator_id: 1,
      distribution_type: 'equally',
      add_joined_members: false,
      images: [],
      members: [
        {
          id: this.#users[1].id,
          amount: 1.83
        },
        {
          id: this.#users[2].id,
          amount: 1.83
        },
        {
          id: this.#users[3].id,
          amount: 1.83
        }
      ]
    },
    {
      id: 2,
      event_id: 1,
      type: 'payment',
      name: 'Beer',
      comment: '',
      amount: 49.99,
      group: this.#itemGroups[1],
      date: '2024-04-06T05:10:00+00:00',
      creator_id: 2,
      distribution_type: 'equally',
      add_joined_members: false,
      images: [],
      members: [
        {
          id: this.#users[1].id,
          amount: 16.66
        },
        {
          id: this.#users[2].id,
          amount: 16.66
        },
        {
          id: this.#users[3].id,
          amount: 16.66
        }
      ]
    },
    {
      id: 3,
      event_id: 1,
      type: 'payment',
      name: 'Chips',
      comment: '',
      amount: 9.48,
      date: '2024-04-06T05:10:00+00:00',
      creator_id: 2,
      distribution_type: 'equally',
      add_joined_members: false,
      images: [],
      members: [
        {
          id: this.#users[1].id,
          amount: 3.16
        },
        {
          id: this.#users[2].id,
          amount: 3.16
        },
        {
          id: this.#users[3].id,
          amount: 3.16
        }
      ]
    },
  ]

  constructor(host) {}

  getToken() {
    if (this.#token) {
      return 'Bearer ' + this.#token;
    }

    return null;
  }

  setToken(token) {
    this.#token = token;
  }

  getLang() {
    return this.#lang;
  }

  setLang(lang) {
    this.#lang = lang;
  }

  async initUserVk(data = {}) {
    this.#initUserData = data;
    console.log('/vk-mini-app', data);
    return new Promise((resolve, reject) => {
      resolve({
        data: {
          token: '1.2.3',
          user_id: 1,
          onboarding: true,
          max_image_size: 1024*1024*5,
          event_limit_balance: 5,
          lang: 'ru',
          add_to_chat_enabled: true,
          generate_event_image_enabled: true,
          show_check_qr_code_scan: true,
          enabled_scan_receipt: true,
        }
      });
    });
  }

  async initUserTelegram(data = {}) {
    this.#initUserData = data;
    console.log('/telegram-bot-app', data);
    return new Promise((resolve, reject) => {
      resolve({
        data: {
          token: 'test',
          user_id: 1,
          max_image_size: 10485760,
          language_code: 'ru',
          onboarding: true,
        },
      });
    });
  }

  async refreshToken() {
    console.log('/auth/refresh');
    return new Promise((resolve, reject) => {
      resolve({
        data: {
          token: 'test',
        }
      });
    });
  }

  async getEvents(offset, q) {
    console.log('/v3/events', offset, q);

    return new Promise((resolve, reject) => {
      const searchValue = prepareString(q).toLowerCase();
      const events = Object.values(this.#events).filter((event) => prepareString(event.name).toLowerCase().indexOf(searchValue) > -1).slice(offset);

      resolve({
        data: {
          events: events,
          count: events.length,
        }
      });
    });
  }

  async getEventV3(id) {
    console.log('/v3/events/' + id);

    return new Promise((resolve, reject) => {
      const response = {
        event: {
          id: 1,
          name: 'Picnic',
          image: {
            id: 1,
            name: 'Picnic image',
            src: 'https://img.freepik.com/free-vector/flat-international-picnic-day-background_23-2150337710.jpg',
            src_s: 'https://img.freepik.com/free-vector/flat-international-picnic-day-background_23-2150337710.jpg'
          },
          invite: 'qwe123qwe123qwe123',
          invite_link: 'https://link.who2who.top/qwe123qwe123qwe123',
          total_amount: 127.49,
          users: [this.#users[1].id, this.#users[2].id, this.#users[3].id],
          is_generate_image: false
        },
        credits: [
          {
            payments_count: 1,
            total_amount: 5.5,
            user_id: this.#users[1].id,
            users: [
              {
                amount: (42.49 - 5.5) / 2,
                user_id: this.#users[2].id
              },
              {
                amount: (42.49 - 5.5) / 2,
                user_id: this.#users[3].id
              }
            ]
          },
          {
            payments_count: 2,
            total_amount: 49.99 + 14.48,
            user_id: this.#users[2].id,
            users: [
              {
                amount: 0,
                user_id: this.#users[1].id
              },
              {
                amount: 0,
                user_id: this.#users[3].id
              }
            ]
          },
          {
            payments_count: 3,
            total_amount: 9.48 + 23.99 + 24.05,
            user_id: this.#users[3].id,
            users: [
              {
                amount: 0,
                user_id: this.#users[1].id
              },
              {
                amount: 0,
                user_id: this.#users[2].id
              }
            ]
          }
        ],
        users: [
          this.#users[1],
          this.#users[2],
          this.#users[3]
        ]
      };

      resolve({
        data: response
      });
    });
  }

  async getEventV4(id) {
    console.log('/v4/events/' + id);

    return new Promise((resolve, reject) => {
      const response = {
        event: {
          id: 1,
          name: 'Picnic',
          image: {
            id: 1,
            name: 'Picnic image',
            src: 'https://img.freepik.com/free-vector/flat-international-picnic-day-background_23-2150337710.jpg',
            src_s: 'https://img.freepik.com/free-vector/flat-international-picnic-day-background_23-2150337710.jpg'
          },
          invite: 'qwe123qwe123qwe123',
          invite_link: 'https://link.who2who.top/qwe123qwe123qwe123',
          total_amount: 127.49,
          users: [this.#users[1].id, this.#users[2].id, this.#users[3].id],
          is_generate_image: false
        },
        credits: [
          {
            creditor_id: this.#users[1].id,
            debtor_id: this.#users[2].id,
            amount: (42.49 - 5.5) / 2
          },
          {
            creditor_id: this.#users[1].id,
            debtor_id: this.#users[3].id,
            amount: (42.49 - 5.5) / 2
          },
          {
            creditor_id: this.#users[2].id,
            debtor_id: this.#users[1].id,
            amount: 0
          },
          {
            creditor_id: this.#users[2].id,
            debtor_id: this.#users[3].id,
            amount: 0
          },
          {
            creditor_id: this.#users[3].id,
            debtor_id: this.#users[1].id,
            amount: 0
          },
          {
            creditor_id: this.#users[3].id,
            debtor_id: this.#users[2].id,
            amount: 0
          },
        ],
        users: [
          this.#users[1],
          this.#users[2],
          this.#users[3]
        ]
      };

      resolve({
        data: response
      });
    });
  }

  async getEventItems(eventId, offset) {
    return new Promise((resolve, reject) => {
      const members = {};
      const items = this.#items.filter((item) => {
        (item.members || []).map((mem) => {
          members[mem.id] = this.#users[mem.id];
        });

        return item.event_id == eventId;
      });

      resolve({
        data: {
          items: items,
          count: items.length,
          members: Object.values(members),
        }
      });

      // const response = {
      //   items: [
      //     {
      //       id: 1,
      //       type: 'payment',
      //       name: 'Vegetables',
      //       comment: '',
      //       amount: 5.5,
      //       date: '2024-04-06T13:20:00+00:00',
      //       creator_id: this.#users[1].id,
      //       distribution_type: 'equally',
      //       add_joined_members: false,
      //       images: [],
      //       members: [
      //         {
      //           id: this.#users[1].id,
      //           amount: 1.83
      //         },
      //         {
      //           id: this.#users[2].id,
      //           amount: 1.83
      //         },
      //         {
      //           id: this.#users[3].id,
      //           amount: 1.83
      //         }
      //       ]
      //     },
      //     {
      //       id: 2,
      //       type: 'payment',
      //       name: 'Beer',
      //       comment: '',
      //       amount: 49.99,
      //       date: '2024-04-06T05:10:00+00:00',
      //       creator_id: this.#users[2].id,
      //       distribution_type: 'equally',
      //       add_joined_members: false,
      //       images: [],
      //       members: [
      //         {
      //           id: this.#users[1].id,
      //           amount: 16.66
      //         },
      //         {
      //           id: this.#users[2].id,
      //           amount: 16.66
      //         },
      //         {
      //           id: this.#users[3].id,
      //           amount: 16.66
      //         }
      //       ]
      //     },
      //     {
      //       id: 3,
      //       type: 'payment',
      //       name: 'Chips',
      //       comment: '',
      //       amount: 9.48,
      //       date: '2024-04-06T05:10:00+00:00',
      //       creator_id: this.#users[2].id,
      //       distribution_type: 'equally',
      //       add_joined_members: false,
      //       images: [],
      //       members: [
      //         {
      //           id: this.#users[1].id,
      //           amount: 3.16
      //         },
      //         {
      //           id: this.#users[2].id,
      //           amount: 3.16
      //         },
      //         {
      //           id: this.#users[3].id,
      //           amount: 3.16
      //         }
      //       ]
      //     },
      //   ],
      //   count: 12,
      //   members: [
      //     this.#users[1],
      //     this.#users[2],
      //     this.#users[3]
      //   ]
      // };
      //
      // resolve({
      //   data: response
      // });
    });
  }

  async generateEventImage(eventId) {
    return this.#post(this.#host + '/v3/events/' + eventId + '/generate_image');
  }

  async getPayment(eventId, paymentId) {
    return this.#get(this.#host + '/v2/events/' + eventId + '/payments/' + paymentId);
  }

  async getRepayment(eventId, repaymentId) {
    return this.#get(this.#host + '/v2/events/' + eventId + '/repayments/' + repaymentId);
  }

  async addEventV3(name, image, generateImage, touchId) {
    const formData = new FormData();
    formData.append('name', name);
    if (image) {
      formData.append('image', image);
    }
    if (generateImage) {
      formData.append('generate_image', 1);
    }

    return this.#post(this.#host + '/v3/events?tId=' + touchId, formData, {'Content-Type': 'multipart/form-data'});
  }

  async updateEventV3(eventId, name, imageId) {
    console.log('/v3/events/' + eventId, {
      name,
      imageId
    });

    return new Promise((resolve, reject) => {
      resolve({
        success: true,
      });
    });
  }

  async addPaymentV3(eventId, name, comment, amount, date, users, creator, type, images, addJoinedMembers, receiptId) {
    const formData = new FormData()
    formData.append('name', name);
    formData.append('amount', amount);
    formData.append('date', new Date(date).toISOString());
    formData.append('comment', comment);
    formData.append('creator', creator);
    formData.append('distribution_type', type);

    if (type === DISTRIBUTION_TYPE_EQUALLY) {
      if (users) {
        users.forEach((userId) => {
          formData.append('users[]', userId);
        });
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    } else if (type === DISTRIBUTION_TYPE_VALUE) {
      for (let userId in users) {
        formData.append('values[' + userId + ']', users[userId]);
      }
    } else if (type === DISTRIBUTION_TYPE_PARTS) {
      for (let userId in users) {
        formData.append('parts[' + userId + ']', users[userId]);
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    }

    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    if (receiptId) {
      formData.append('receipt_id', type);
    }

    return this.#post(this.#host + '/v3/events/' + eventId + '/payments', formData, {'Content-Type': 'multipart/form-data'});
  }

  async uploadItemImageV3(eventId, img) {
    const formData = new FormData();
    formData.append('image', img);

    return this.#post(this.#host + '/v3/events/' + eventId + '/items/upload', formData, {'Content-Type': 'multipart/form-data'});
  }

  async uploadEventImageV3(img) {
    const formData = new FormData();
    formData.append('image', img);

    return this.#post(this.#host + '/v3/events/upload', formData, {'Content-Type': 'multipart/form-data'});
  }

  async addEventItemsMany(eventId, items, date, creatorId, addJoinedMembers, receiptId) {
    const formData = new FormData();

    formData.append('date', new Date(date).toISOString());
    formData.append('creator', creatorId);
    formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    if (receiptId) {
      formData.append('receipt_id', receiptId);
    }

    items.forEach((item, number) => {
      formData.append('items[' + number + '][name]', item.name);
      formData.append('items[' + number + '][comment]', item.comment);
      formData.append('items[' + number + '][amount]', item.amount);
      item.users.forEach((user) => {
        formData.append('items[' + number + '][users][]', user.id || user.value || user);
      });
    });

    return this.#post(this.#host + '/v2/events/' + eventId + '/payments/many', formData, {'Content-Type': 'multipart/form-data'});
  }

  async updatePaymentV4(eventId, itemId, name, comment, price, date, users, creator, type, images, addJoinedMembers, updateToken) {
    const formData = new FormData()
    formData.append('name', name);
    formData.append('comment', comment);
    formData.append('amount', price);
    formData.append('date', new Date(date).toISOString());
    formData.append('creator', creator);
    formData.append('distribution_type', type);
    formData.append('update_token', updateToken);

    if (type === DISTRIBUTION_TYPE_EQUALLY) {
      if (users) {
        users.forEach((userId) => {
          formData.append('users[]', userId);
        });
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    } else if (type === DISTRIBUTION_TYPE_VALUE) {
      for (let userId in users) {
        formData.append('values[' + userId + ']', users[userId]);
      }
    } else if (type === DISTRIBUTION_TYPE_PARTS) {
      for (let userId in users) {
        formData.append('parts[' + userId + ']', users[userId]);
      }
      formData.append('add_joined_members', addJoinedMembers ? 1 : 0);
    }

    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    return this.#post(this.#host + '/v4/events/' + eventId + '/payments/' + itemId, formData, {'Content-Type': 'multipart/form-data'});
  }

  async deletePaymentV1(eventId, itemId) {
    return this.#delete(this.#host + '/events/' + eventId + '/payments/' + itemId);
  }

  async createInvite(eventId) {
    return this.#post(this.#host + '/events/' + eventId + '/invite');
  }

  async invite(invite) {
    return this.#get(this.#host + '/join/' + invite);
  }

  async leaveEvent(eventId) {
    return this.#post(this.#host + '/events/' + eventId + '/leave');
  }

  async members() {
    return this.#get(this.#host + '/members');
  }

  async scanReceipt(eventId, file) {
    console.log('/v2/events/' + eventId + '/receipt', file);
  }

  async getReceiptInfo(eventId, receiptId) {
    console.log(this.#host + '/v2/events/' + eventId + '/receipt/' + receiptId);
  }

  async getReceipts(eventId, offset) {
    console.log(this.#host + '/v2/events/' + eventId + '/receipt', {
      offset: offset,
    });

    return new Promise((resolve, reject) => {
      resolve({
        data: {
          total: 0,
          items: [],
        }
      });
    });
  }

  async scanQr(eventId, codeData) {
    console.log('/v3/events/' + eventId + '/scan_qr?=data=' + codeData.code_data);

    return new Promise((resolve, reject) => {
      const response = {
        status: 'FULL',
        name: 'ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ \"АГРОТОРГ\"',
        items: [
          {
            name: 'Пакет ПЯТЕРОЧКА 65х40см',
            amount: 6.29,
            total_amount: 6.29,
            quantity: 1
          },
          {
            name: 'CHILLOUT Нап.PR.EN.T.ПЭТ 0.9л',
            amount: 94.49,
            total_amount: 94.49,
            quantity: 1
          },
          {
            name: 'Наст.ЗИМ.ДЕР.ГР.ВИШ.0.5л',
            amount: 212.6,
            total_amount: 212.6,
            quantity: 1
          },
          {
            name: 'Мол.МУР.ПОДВ.паст.3,2% п\/п0,87л',
            amount: 59.99,
            total_amount: 59.99,
            quantity: 1
          },
          {
            name: '*GREENF.Чай Ear.Gr.Fan.bl.100х2г',
            amount: 259.85,
            total_amount: 259.85,
            quantity: 1
          },
          {
            name: 'ЗОЛ.КОЛ.Хлеб ДАРН.форм.нар.325г',
            amount: 37.99,
            total_amount: 37.99,
            quantity: 1
          },
          {
            name: '*МОС.ПР.Майонез на пер.яйц.600мл',
            amount: 118.11,
            total_amount: 118.11,
            quantity: 1
          },
          {
            name: '*GR.Сыр с гол.благ.плес.50% 100г',
            amount: 179.99,
            total_amount: 179.99,
            quantity: 1
          },
          {
            name: '*ВЛ.СТ.Колб.ДОК.СТАН.кур.вар430г',
            amount: 109.99,
            total_amount: 219.98,
            quantity: 2
          },
          {
            name: '*GL.VIL.Крупа БУЛГУР пшен.450г',
            amount: 79.99,
            total_amount: 79.99,
            quantity: 1
          },
          {
            name: 'К.Ц.Яйца кур.стол.С0 10шт',
            amount: 79.99,
            total_amount: 79.99,
            quantity: 1
          },
          {
            name: '*GL.VIL.Горошек конс зел.400г',
            amount: 49.6,
            total_amount: 49.6,
            quantity: 1
          }
        ],
        date: '2023-02-25T17:36:00+00:00',
        totalPrice: 1398.87
      };

      resolve({
        data: response
      });
    });
  }

  async log(data) {
    return this.#post(this.#host + '/log', data);
  }

  async eventDeleteUser(eventId, userId) {
    return this.#delete(this.#host + '/events/' + eventId + '/users/' + userId);
  }

  async createRepaymentV3(eventId, from, to, amount, date, comment, images) {
    const formData = new FormData()
    formData.append('from', from);
    formData.append('to', to);
    formData.append('comment', comment);
    formData.append('amount', amount);
    formData.append('date', new Date(date).toISOString());
    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    return this.#post(this.#host + '/v3/events/' + eventId + '/repayments', formData, {'Content-Type': 'multipart/form-data'});
  }

  async updateRepaymentV3(eventId, itemId, from, to, amount, date, comment, images, updateToken) {
    let formData = new FormData()
    formData.append('from', from);
    formData.append('to', to);
    formData.append('amount', amount);
    formData.append('date', new Date(date).toISOString());
    formData.append('comment', comment);
    formData.append('update_token', updateToken);
    if (images.length > 0) {
      images.forEach((img) => {
        formData.append('images[]', img);
      });
    } else {
      formData.append('images', []);
    }

    return this.#post(this.#host + '/v3/events/' + eventId + '/repayments/' + itemId, formData, {'Content-Type': 'multipart/form-data'});
  }

  async deleteRepaymentV1(eventId, itemId) {
    return this.#delete(this.#host + '/events/' + eventId + '/repayments/' + itemId);
  }

  async profile() {

    return new Promise((resolve, reject) => {
      console.log(this.#host + '/profile');

      return resolve({
        data: {
          payment_info: "",
          notify_user_joined_event: true,
          notify_user_added_payment: true,
          remaining_receipt_scans_count: 5,
          remaining_events_count: 5,
        }
      });
    });
  }

  async updateProfile(data) {
    return this.#post(this.#host + '/v2/profile', data);
  }

  async passedOnBoarding() {
    return this.#post(this.#host + '/profile/passed_on_boarding');
  }

  async sendInviteMessage(eventId) {
    return this.#post(this.#host + '/events/' + eventId + '/send_invite_tg');
  }

  async #post(url, data, headers = {}) {
    return new Promise((resolve, reject) => {
      console.log(url, data, headers);

      return resolve({});
    });
  }

  async #get(url, params = {}) {
    return new Promise((resolve, reject) => {
      console.log(url, data, headers);

      return resolve({});
    });
  }

  async #delete(url, params = {}) {
    return new Promise((resolve, reject) => {
      console.log(url, data, headers);

      return resolve({});
    });
  }

}

export default HttpClient;
